import {
    BaseTransitionModel,
} from '@src/slide/domain/ui-model/element-modeles/transition/transition-model/base-transition-model';
import { IAnimationSetting, INewsflashTransition } from '@src/slide/domain/ui-model/element-modeles/transition/interface';
import { TransitionTarget, TransitionType } from '@src/slide/domain/ui-model/element-modeles/transition/constants';
import { TransitionConfig } from '@src/slide/domain/ui-model/element-modeles/transition/config';

export class NewsflashTransitionModel extends
    BaseTransitionModel<INewsflashTransition> implements INewsflashTransition {
    public type = TransitionType.NEWSFLASH;

    public getAnimationSetting(isSwitchForward): IAnimationSetting[] {
        if (isSwitchForward) {
            return [{
                fromStyle: {
                    ...TransitionConfig.OPACITY_SHOW,
                    ...TransitionConfig.SCALE_NORMAL,
                    ...TransitionConfig.ROTATE_ZERO,
                },
                toStyle: {
                    ...TransitionConfig.SCALE_ZERO,
                    ...TransitionConfig.OPACITY_HIDE,
                    ...TransitionConfig.ROTATE_TWO_TURNS,
                },
                target: TransitionTarget.EXIT,
            }];
        }
        return [{
            fromStyle: {
                ...TransitionConfig.Z_INDEX_LEVEL_1,
                ...TransitionConfig.SCALE_ZERO,
                ...TransitionConfig.OPACITY_HIDE,
                ...TransitionConfig.ROTATE_TWO_TURNS,
            },
            toStyle: {
                ...TransitionConfig.Z_INDEX_LEVEL_1,
                ...TransitionConfig.OPACITY_SHOW,
                ...TransitionConfig.SCALE_NORMAL,
                ...TransitionConfig.ROTATE_ZERO,
            },
            target: TransitionTarget.ENTER,
        }];
    }
}
